module.exports = __webpack_public_path__ + "img/logo.a73fd5d2.png";